import { useRecoilValue } from 'recoil'
import { formatPrice, isPriced } from '@messenger/utils'
import { caseImageVariantPricingAtom } from '@/atoms/caseImageAtoms'

/**
 * The per-use price of an Enhance as the copy shows it ("$1.00"), or null
 * while the pricing atom holds no usable amount for it. Every Enhance
 * surface (the disclosure and accept button, the tile's low-resolution
 * badge, the canvas warning's link) picks its copy without an amount on
 * null, so no placeholder number is ever shown. A price of zero is a real
 * price and reads "$0.00".
 */
export const useUpscalePriceLabel = (): string | null => {
  const pricing = useRecoilValue(caseImageVariantPricingAtom)
  const cents = pricing?.UPSCALE
  return isPriced(cents) ? formatPrice(cents) : null
}
